const getLimitsForDisplay = <T extends object>(
  limits: T,
  baseTypes: string[],
) => {
  const limitsRecord = limits as Record<string, any>;
  const result: Record<string, any> = {};
  const keys = Object.keys(limitsRecord);

  keys.forEach((transactionType) => {
    if (
      !baseTypes.some(
        (baseType) =>
          transactionType === baseType ||
          transactionType.startsWith(`${baseType}.`),
      )
    ) {
      return;
    }

    result[transactionType] = {};
    const limitForTransaction = limitsRecord[transactionType];
    if (!limitForTransaction || Object.keys(limitForTransaction).length === 0) {
      return;
    }

    const limitsForTransactionKeys = Object.keys(
      limitForTransaction,
    ) as (keyof typeof limitForTransaction)[];

    limitsForTransactionKeys.forEach((key) => {
      // limits[transactionType] has numeric period keys and metadata keys; only periods are displayed.
      if (Number(key) && limitForTransaction[key] !== undefined) {
        result[transactionType][key] = limitForTransaction[key];
      }
    });
  });

  return result;
};

export default getLimitsForDisplay;
